// @flow
import React from 'react';
import HitLabel from '../HitLabel/HitLabel';
type Props = {
    formatMessage: any,
    freeCancellationUntil?: string,
    isDesktop?: boolean,
    parentNode?: ?HTMLBodyElement
};

const HitFreeCancellation = ({
    formatMessage,
    freeCancellationUntil,
    isDesktop,
    parentNode
}: Props) => {
    const freeCancellationLabel = formatMessage({
        id: 'freeCancellation',
        description: 'Free cancellation',
        defaultMessage: 'Free cancellation'
    });
    const freeCancellationToolTip = formatMessage(
        {
            id: 'freeCancellationTooltip',
            description: 'Free Cancellation until {date}',
            defaultMessage: 'Free Cancellation until {date}'
        },
        {
            date: freeCancellationUntil
        }
    );

    if (isDesktop) {
        return (
            <HitLabel
                label={freeCancellationLabel}
                toolTipText={freeCancellationToolTip}
                parentNode={parentNode}
            />
        );
    }
    return <HitLabel label={freeCancellationLabel} />;
};

export default HitFreeCancellation;
